import AbstractAsyncDetailTablePage from '../abstract-async-detail-table-page';
import SearchForm from '../../model/search-form';
import DeliveryData from '../../model/delivery-data';

import DeliveryNoteSearchForm from '../../components/orders/delivery-note-search-form';
import Table from '../../components/shared/table';
import HTMLTemplateHelper from '../../helpers/html-template-helper';
import MessageHelper from '../../helpers/message-helper';
import { formatDate, formatTime } from '../../helpers/utils';
import DeliveryEntryData from '../../model/delivery-entry-data';

export default class DeliveryNotePage extends AbstractAsyncDetailTablePage<DeliveryData> {
  protected readonly searchForm: SearchForm;
  protected readonly table: Table;
  protected readonly tableColumnDefinitions: DataTables.ColumnDefsSettings[] = [
    {
      className: 'js-showDetails',
      targets: 0,
      orderable: false,
      searchable: false,
      data: null,
      defaultContent: '<i class="table__toggle-child fas fa-chevron-right"></i>',
    }, {
      targets: 1,
      data: (data: DeliveryData): string => `<a>${data.id}</a>`, // eslint-disable-line max-len
      className: 'cursor-pointer js-showDetails',
    },
    { targets: 2, data: 'orderId' },
    { targets: 3, data: 'status' },
    {
      targets: 4,
      data: (data: DeliveryData, type: string): string | number => {
        if (data.submittedDate === null) {
          return 0;
        }
        if (type === 'sort') {
          return data.submittedDate;
        }
        return formatDate(new Date(data.submittedDate));
      },
    }, {
      targets: 5,
      data: (data: DeliveryData, type: string): string | number => {
        if (data.submittedDate === null) {
          return 0;
        }
        if (type === 'sort') {
          return data.submittedDate;
        }
        return formatTime(new Date(data.submittedDate));
      },
    },
    {
      targets: 6,
      data: (data: DeliveryData, type: string): string | number => {
        if (data.requestedDeliveryDate === null) {
          return 0;
        }
        if (type === 'sort') {
          return data.requestedDeliveryDate;
        }
        return formatDate(new Date(data.requestedDeliveryDate));
      },
    },
    { targets: 7, data: 'quantity', className: 'text-align-right' },
    { targets: 8, data: 'receivingPoint' },
    { targets: 9, data: 'grossWeight' },
    {
      targets: 10,
      className: 'text-align-center',
      data: (data: DeliveryData): string => HTMLTemplateHelper.createLinkButton({
        buttonClass: '-clear -compact',
        href: `${window.ACC.config.encodedContextPath}/orders/deliverynote/print?token=${data.fileDownloadJwt}`,
        text: MessageHelper.getMessage('common.print'),
        textClass: 'sr-only',
        icon: 'fas fa-file-download',
      }).outerHTML,
    },
  ];

  protected detailTableTemplate: JQuery<HTMLTemplateElement>;
  protected detailTableColumnDefinitions: DataTables.ColumnDefsSettings[] = [
    { targets: 0, data: 'id', width: '2%' },
    { targets: 1, data: 'materialNumber', width: '15%' },
    {
      targets: 2, data: 'quantity', width: '10%', className: 'text-align-right',
    },
    { targets: 3, data: 'materialDescription', width: '15%' },
    { targets: 4, data: 'status', width: '10%' },
    {
      targets: 5, data: 'openedQuantity', width: '10%', className: 'text-align-right',
    },
    {
      targets: 6,
      data: (entry: DeliveryEntryData): string => `
            <a href="${window.ACC.config.encodedContextPath}/orders/orderedItems?orderId=${entry.orderNumber}">${entry.orderNumber}</a>`,
      width: '15%',
    },
    {
      targets: 7,
      data: (entry: DeliveryEntryData): string => `
            <a href="${window.ACC.config.encodedContextPath}/orders/invoice?id=${entry.invoiceNumber}">${entry.invoiceNumber}</a>`,
      width: '15%',
    },
  ];

  constructor(body: JQuery) {
    super();
    this.searchForm = new DeliveryNoteSearchForm(body.find('.js-deliveryNoteForm') as JQuery<HTMLFormElement>);
    this.detailTableTemplate = body.find<HTMLTemplateElement>('#js-deliveryNoteDetailsTemplate');
    this.table = new Table(body.find('.js-table'), this.tableColumnDefinitions, { drawCallback: this.generateDrawCallback('id') });
    this.bindAsyncData();
    this.bindShowDetails();
  }

  // eslint-disable-next-line class-methods-use-this
  protected getDetailUrl(data: DeliveryData): string {
    return `${window.ACC.config.encodedContextPath}/orders/deliverynote/details/${data.id}`;
  }
}
